
























import { Component, Vue, Prop } from 'vue-property-decorator';
import GrowingNumber from '@/components/GrowingNumber.vue';

@Component({
  components: {
    GrowingNumber
  }
})
export default class NumCardWidget extends Vue {
  
  @Prop({ default: '',  type: String}) icon!: string;
  @Prop({ default: 0,  type: Number}) number!: number;
  @Prop({ default: '',  type: String}) prefix!: string;
  @Prop({ default: '',  type: String}) suffix!: string;
  @Prop({ default: '',  type: String}) label!: string;
  @Prop({ default: '',  type: String}) type!: string;
  @Prop({ default: false,  type: Boolean}) showDecimals!: boolean;
  
}
